/*
	Inicia a configuração de um Chart
*/
export default ({ commit }, { chartState }) => 
	commit("configureChart", { chartState })

